export interface InvestorDeckRequest {
  name: string;
  firm: string;
  email: string;
  reason: string;
}

/**
 * Simulates the ZP-53 gated deck-request flow locally (same pattern as
 * leadCapture.ts's submitLead / newsletter.ts's subscribeToNewsletter).
 * Real routing would POST to a Cloud Function that emails founders/BD and
 * logs the enquiry in a CRM with source "Investor Deck Request" — swap the
 * body for that call once one exists. No reCAPTCHA is attempted here: a
 * fake badge with no real site key or backend verification behind it would
 * be a more deceptive UI than just omitting it, same scoped-down call
 * ZP-24's pincode checker already made for the same reason.
 */
export async function submitInvestorDeckRequest(request: InvestorDeckRequest): Promise<{ ok: true }> {
  if (import.meta.env.DEV) {
    console.info("[investorDeckRequest] would POST to deck-request Cloud Function:", request);
  }
  // TODO(backend): POST to a real endpoint, e.g.
  // await fetch("/api/investor-deck-request", { method: "POST", body: JSON.stringify(request) });
  await new Promise((resolve) => setTimeout(resolve, 500));
  return { ok: true };
}
